/**
 * Savage Lab — ventana de bienvenida. Sin librerías.
 *
 * Aparece a los N segundos, se puede cerrar con la X, el velo o Escape, y
 * recuerda el cierre para no volver a molestar durante los días configurados.
 * El código se copia al portapapeles con un clic.
 */
class SlPopup extends HTMLElement {
  connectedCallback() {
    this.clave = this.dataset.clave || 'sl-popup';
    if (this.yaVisto()) return;

    // En el editor de temas conviene verlo siempre y sin espera.
    const enEditor = document.documentElement.classList.contains('shopify-design-mode');
    const retraso = enEditor ? 0 : (parseInt(this.dataset.retraso, 10) || 0) * 1000;

    this.temporizador = setTimeout(() => this.mostrar(), retraso);

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-cerrar]')) this.cerrar();
      const cod = e.target.closest('[data-copiar]');
      if (cod) this.copiar(cod);
    });

    this.alTeclado = (e) => {
      if (e.key === 'Escape') this.cerrar();
    };
  }

  disconnectedCallback() {
    clearTimeout(this.temporizador);
    document.removeEventListener('keydown', this.alTeclado);
  }

  yaVisto() {
    try {
      const hasta = localStorage.getItem(this.clave);
      return hasta && Number(hasta) > Date.now();
    } catch (e) {
      return false; // navegación privada: mejor mostrarlo que fallar
    }
  }

  mostrar() {
    this.hidden = false;
    // Un fotograma después, para que la transición de entrada se vea.
    requestAnimationFrame(() => this.classList.add('sl-popup--visible'));
    document.addEventListener('keydown', this.alTeclado);
    const cerrarBtn = this.querySelector('.sl-popup__x');
    if (cerrarBtn) cerrarBtn.focus();
  }

  cerrar() {
    this.classList.remove('sl-popup--visible');
    document.removeEventListener('keydown', this.alTeclado);
    const dias = parseInt(this.dataset.dias, 10) || 14;
    try {
      localStorage.setItem(this.clave, String(Date.now() + dias * 86400000));
    } catch (e) {
      /* sin almacenamiento: se volverá a ver, no pasa nada */
    }
    setTimeout(() => {
      this.hidden = true;
    }, 400);
  }

  copiar(boton) {
    const texto = boton.dataset.copiar;
    const aviso = boton.querySelector('.sl-popup__codigo-aviso');
    const listo = () => {
      if (!aviso) return;
      aviso.textContent = 'Copiado';
      boton.classList.add('sl-popup__codigo--copiado');
      setTimeout(() => {
        aviso.textContent = '';
        boton.classList.remove('sl-popup__codigo--copiado');
      }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(texto).then(listo).catch(() => {});
    } else {
      // Respaldo para navegadores sin API de portapapeles
      const t = document.createElement('textarea');
      t.value = texto;
      t.setAttribute('readonly', '');
      t.style.position = 'absolute';
      t.style.left = '-9999px';
      document.body.appendChild(t);
      t.select();
      try {
        document.execCommand('copy');
        listo();
      } catch (e) {
        /* nada */
      }
      document.body.removeChild(t);
    }
  }
}

if (!customElements.get('sl-popup')) {
  customElements.define('sl-popup', SlPopup);
}
